import { motion } from "framer-motion";

const IMAGES = [
  {
    src: "/photos/campeggio-riva.jpg",
    alt: "Bivacco in riva al tramonto",
    cls: "aspect-[3/4] md:mt-0",
  },
  {
    src: "/photos/brolly-tramonto.jpg",
    alt: "Brolly e canne al tramonto sul lago",
    cls: "aspect-[4/3] md:mt-16",
  },
  {
    src: "https://images.unsplash.com/photo-1790616030406-58da32307d3f?auto=format&fit=crop&w=1200&q=80",
    alt: "Carpa in acque scure",
    cls: "aspect-[3/4] md:mt-8",
  },
];

const CREEDS = ["Nessuno sponsor", "Nessuna scelta", "Tutta la notte"];

export default function Manifesto() {
  return (
    <section
      id="manifesto"
      data-testid="manifesto-section"
      className="bg-ink border-t border-ink-border px-5 md:px-10 py-20 md:py-32"
    >
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20">
        <div>
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
            className="font-mono text-[10px] md:text-xs uppercase tracking-[0.35em] text-ember mb-6"
          >
            Manifesto
          </motion.p>
        <div className="relative">
          <img
            src="https://customer-assets-eiarnc6j.emergentagent.net/job_sub-surface-carp/artifacts/7867ahf8_stillwater.png"
            alt="Stillwater — timbro"
            data-testid="manifesto-stamp"
            className="hidden md:block absolute -top-20 right-2 w-36 rotate-[12deg] opacity-75 mix-blend-screen pointer-events-none"
          />
          <motion.blockquote
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 1, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
            className="font-serif font-light italic text-3xl md:text-5xl leading-[1.15] tracking-tight"
          >
            "La carpa non è un hobby. È un modo di
            <span className="text-ember"> guardare l'acqua</span> mentre tutti
            guardano altrove."
          </motion.blockquote>
        </div>
          <motion.p
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.9, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
            className="mt-8 max-w-lg text-sm md:text-base text-mist leading-relaxed"
          >
            Stillwater nasce come circolare indipendente: nessuna Casa
            dietro, nessun catalogo da riempire. Solo macchine da presa,
            nottate vere e domande scomode a chi il carpfishing lo vende.
            Pubblichiamo quando abbiamo qualcosa da dire, non quando il
            calendario lo chiede.
          </motion.p>
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.9, delay: 0.3 }}
            className="mt-6 font-mono text-[10px] uppercase tracking-[0.3em] text-faint"
          >
            — La redazione, da qualche riva italiana
          </motion.p>

          <div className="mt-10 flex flex-wrap gap-3">
            {CREEDS.map((c, i) => (
              <motion.span
                key={c}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.7, delay: 0.1 * i, ease: [0.16, 1, 0.3, 1] }}
                className="font-mono text-[10px] uppercase tracking-[0.25em] border border-ink-border rounded-full px-5 py-2.5 text-mist hover:text-ember hover:border-ember transition-colors duration-300"
              >
                {c}
              </motion.span>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4 md:gap-6">
          {IMAGES.map((img, i) => (
            <motion.div
              key={img.src}
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 1, delay: 0.12 * i, ease: [0.16, 1, 0.3, 1] }}
              className={`overflow-hidden border border-ink-border ${img.cls} ${
                i === 0 ? "col-span-2 md:col-span-1" : ""
              }`}
            >
              <img
                src={img.src}
                alt={img.alt}
                loading="lazy"
                className="h-full w-full object-cover hover:scale-[1.04] transition-transform duration-[1.4s] ease-[cubic-bezier(0.16,1,0.3,1)]"
              />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
